import { render, staticRenderFns } from "./addSocialLinks.vue?vue&type=template&id=5a165917"
import script from "./addSocialLinks.vue?vue&type=script&lang=js"
export * from "./addSocialLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports